import React from "react";
//Material imports
import { withStyles } from "@material-ui/core/styles";
import Fade from "@material-ui/core/Fade";

var SlideImage = function SlideImage(_ref) {
  var classes = _ref.classes,
      imgSrc = _ref.imgSrc,
      primaryColour = _ref.primaryColour,
      shouldAnimate = _ref.shouldAnimate,
      _ref$roundImage = _ref.roundImage,
      roundImage = _ref$roundImage === void 0 ? false : _ref$roundImage;
  return /*#__PURE__*/React.createElement(Fade, {
    in: true,
    timeout: 500,
    style: {
      transitionDelay: "0.4s"
    },
    appear: shouldAnimate
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.imgContainer,
    style: {
      backgroundColor: primaryColour
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: imgSrc,
    className: roundImage ? classes.round : classes.img
  })));
};

var styles = {
  imgContainer: {
    justifyContent: "center",
    display: "flex",
    flex: "1",
    alignItems: "center"
  },
  img: {
    maxWidth: 320,
    maxHeight: "100%"
  },
  round: {
    maxWidth: 150,
    maxHeight: "100%",
    borderRadius: "50%"
  }
};
export default withStyles(styles)(SlideImage);